import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'dpl/common/components/Icon';

export default function FixedTooltip({ title, onCloseClick }) {
  return (
    <div className="FixedTooltip bg-white br3 br--top ph4 pt3 pb8 ba b--light-gray">
      <div className="tr f0">
        <button
          type="button"
          onClick={ onCloseClick }
          className="black-50"
          data-test-id="close-button"
        >
          <Icon name="close" />
        </button>
      </div>
      { title }
    </div>
  );
}

FixedTooltip.propTypes = {
  title: PropTypes.node.isRequired,
  onCloseClick: PropTypes.func.isRequired
};
